import ClePipelineView from './ClePipelineView'

export default ClePipelineView
